import { render, staticRenderFns } from "./video-library-item.vue?vue&type=template&id=e0701010&scoped=true"
import script from "./video-library-item.vue?vue&type=script&lang=js"
export * from "./video-library-item.vue?vue&type=script&lang=js"
import style0 from "./video-library-item.vue?vue&type=style&index=0&id=e0701010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0701010",
  null
  
)

export default component.exports